import foodImage from '@/assets/images/food.png?url';
import sportImage from '@/assets/images/swiper-sport.svg?url';
import clinicImage from '@/assets/images/swiper-clinic-item.svg?url';
import clinicEmpty from '@/assets/images/swiper-clinic-doctor.svg?url';
import helpdeskEmpty from '@/assets/images/swiper-helpdesk.svg?url';
import helpdeskImage from '@/assets/images/swiper-helpdesk-image.svg?url';
import transportImage from '@/assets/images/swiper-transport-item.svg?url';
import dormitoryImage from '@/assets/images/swiper-dormitory.svg?url';
import dormitoryEmpty from '@/assets/images/swiper-dormitory-empty.svg?url';
import transportEmpty from '@/assets/images/swiper-transport.svg?url';
import foodEmpty from '@/assets/images/food-empty.png?url';
import sportEmpty from '@/assets/images/sport-empty.svg?url';
import { envConfig } from '@/configs';

export const textColor = (variant: ComponentVariant) => ({
  nurture: 'text-primary-dark',
  sport: 'text-sport-darker',
  health: 'text-health-darker',
  transport: 'text-transport-darker',
  helpdesk: 'text-helpdesk',
  dormitory: 'text-dormitory',
}[variant]);

export const getImage = (variant: ComponentVariant) => ({
  nurture: foodImage,
  sport: sportImage,
  health: clinicImage,
  transport: transportImage,
  helpdesk: helpdeskImage,
  dormitory: dormitoryImage,
}[variant]);

export const swiperEmptyImage = (variant: ComponentVariant) => ({
  nurture: <img
    src={foodEmpty}
    className="swiper-img object-contain object-center"
    alt="Food Empty Image"
    style={{
      width: '100%',
      maxWidth: '180px',
      filter: envConfig?.ui?.swiperShadow ? 'drop-shadow(rgba(0, 0, 0, 0.3) 2px 7px 5px)' : undefined
    }}
  />,
  sport: <img
    src={sportEmpty}
    alt="Sport Empty Image"
    style={{ width: '100%', maxWidth: '350px', maxHeight: '250px' }}
  />,
  health: <img
    src={clinicEmpty}
    alt="Health Empty Image"
    style={{ width: '100%', maxWidth: '350px', maxHeight: '250px' }}
  />,
  transport: <img
    src={transportEmpty}
    alt="Transport Empty Image"
    style={{ width: '100%', maxWidth: '350px', maxHeight: '250px' }}
  />,
  helpdesk: <img
    src={helpdeskEmpty}
    alt="Helpdesk Empty Image"
    style={{ width: '100%', maxWidth: '350px', maxHeight: '250px' }}
  />,
  dormitory: <img
    src={dormitoryEmpty}
    alt="Dormitory Empty Image"
    style={{ width: '100%', maxWidth: '350px', maxHeight: '250px' }}
  />
}[variant]);
